export const AGENT_API_URL =
  import.meta.env.VITE_AGENT_API_URL ||
  `${import.meta.env.VITE_REST_API_URL?.replace(/\/api$/, '')}/api/agent`;
